import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { SerializedStyles, css } from '@emotion/core'
import { Trans } from 'react-i18next'

type Props<T = string> = {
  tabs: ReadonlyArray<{
    path: string
    name: T
  }>
  currentTab: T
  customTabStyle?: SerializedStyles
  /** tablist の aria-label（任意） */
  ariaLabel?: string
}

export const SettingTab = <T,>({ currentTab, tabs, customTabStyle, ariaLabel }: React.PropsWithChildren<Props<T>>) => {
  const history = useHistory()
  const location = useLocation()

  const goTo = (path: string) => {
    history.push({ pathname: path, search: location.search })
  }

  return (
    <div css={settingTabContainerStyle} role="tablist" aria-label={ariaLabel}>
      {tabs.map(tab => {
        const isActive = currentTab === tab.name
        return (
          <div
            key={tab.path}
            role="tab"
            tabIndex={0}
            aria-selected={isActive}
            css={[isActive ? settingTabActiveStyle : settingTabStyle, customTabStyle]}
            onClick={() => {
              if (isActive) return
              goTo(tab.path)
            }}
            onKeyDown={e => {
              if (e.key !== 'Enter' && e.key !== ' ') return
              e.preventDefault()
              if (isActive) return
              goTo(tab.path)
            }}
          >
            <Trans i18nKey={tab.name as string} />
          </div>
        )
      })}
    </div>
  )
}
const centerStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  wordBreak: 'keep-all',
  overflowWrap: 'break-word',
  textAlign: 'center',
})

const settingTabContainerStyle = css({
  height: 45,
  display: 'flex',
})

const settingTabStyle = css(centerStyle, {
  width: 134,
  height: 45,
  borderRadius: '5px 5px 0 0',
  background: '#F5F5F5',
  boxShadow: '0px 0px 6px #0000001A',
  fontSize: 14,
  fontWeight: 'bold',
  color: '#676767',
  '&:hover': {
    cursor: 'pointer',
    opacity: 0.8,
  },
  '&:focus-visible': {
    outline: '2px solid #F2A40B',
    outlineOffset: 2,
  },
})

const settingTabActiveStyle = css(centerStyle, {
  width: 134,
  height: 41,
  borderRadius: '5px 5px 0 0',
  background: '#fff',
  boxShadow: '0px 0px 6px #0000001A',
  position: 'relative',
  fontSize: 14,
  fontWeight: 'bold',
  color: '#F2A40B',
  '&:focus-visible': {
    outline: '2px solid #F2A40B',
    outlineOffset: 2,
  },
  '&::after': {
    position: 'absolute',
    bottom: -4,
    left: 0,
    height: 6,
    width: '100%',
    content: '""',
    background: '#fff',
    zIndex: 3,
  },
})
